import { render } from "./LocationsPage.vue?vue&type=template&id=2bd3ff94&scoped=true"
import script from "./LocationsPage.vue?vue&type=script&lang=js"
export * from "./LocationsPage.vue?vue&type=script&lang=js"

import "./LocationsPage.vue?vue&type=style&index=0&id=2bd3ff94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd3ff94"]])

export default __exports__